import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Content from './Content';
import Favorites from '../favorites/Favorites';

function Catalog() {
    return (
        <React.Fragment>
            <Favorites/>
            <Header/>
            <Content/>
            <Footer/>
        </React.Fragment>
    );
}

export default Catalog;
